import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BridgedImg from "./images/bridged.png";
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import NumberAnimated from './NumberAnimated';

const Bridged = () => {
  const [loggedInUsername, setLoggedInUsername] = useState('');
  const username = localStorage.getItem('username');
  const isLoggedIn = localStorage.getItem('token');
  const [users, setUsers] = useState([]);
  const [startDate, setStartDate] = useState('');
const [endDate, setEndDate] = useState('');
  const API_URL = 'https://accessi.sgsmails.com/api.php';
  const fetchData = async (tableName) => {
    try {
    const response = await axios.get(`${API_URL}/items?table=${tableName}`);
    if (Array.isArray(response.data)) {
    setUsers(response.data);
    } else {
    throw new Error('Data is not in expected format');
    }
    } catch (error) {
    console.error('Failed to fetch data:', error);
    toast.error('Error fetching data.');
    }
    };
    useEffect(() => {
    fetchData('bridged');
    setLoggedInUsername(username);
    }, []);
  
  const sumColumn = (columnName) => {
    if (users.length === 0) {
    return 0; // Return default value or handle empty state
    }
    
    return users.reduce((total, user) => {
    const value = Number(user[columnName]);
    return total + (isNaN(value) ? 0 : value);
    }, 0);
    };
  
    const deleteUser = async (id) => {
      const shouldDelete = window.confirm('Are you sure you want to delete this?');
      if (shouldDelete) {
        try {
        await axios.delete(`${API_URL}?id=${id}&table=bridged`);
        setUsers(users.filter(user => user.ID !== id));
        toast.success('User deleted successfully.');
        } catch (error) {
        console.error('Error deleting user:', error);
        toast.error('Failed to delete user.');
        }
        }
      };
    
    
    

      const filterData = (event) => {
      
        // Filter the data based on the selected start and end dates
        const filteredData = users.filter(userData => {
        const date = new Date(userData.do);
        return date >= new Date(startDate) && date <= new Date(endDate);
        });
        // Update the state with the filtered data
        setUsers(filteredData);
        event.preventDefault();
        };
  
        const resetData = (event) => {
          fetchData('bridged');
          event.preventDefault();
          };
  return (
    <div className='w-full h-auto flex justify-center items-center flex-wrap flex-col bg-white backdrop-filter backdrop-blur-sm bg-opacity-30 p-6 rounded-md mt-8'>
      <div className='w-full h-auto bg-white flex justify-start items-center border-red-700 border-l-4 py-2 px-4 rounded-sm'>
        <img src={BridgedImg} width={40} alt="Bridged" />
        <h1 className='ml-2 text-sky-800 text-xl font-bold'>Bridget</h1>
      </div>
      <div className='w-full h-auto flex md:justify-between justify-center flex-wrap items-start mt-6'>
      <div className='h-auto md:w-[32%] w-full bg-white border-blue-700 bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 border-b-4 py-4 px-3 rounded-md'>
            <h1 className='text-lg text-gray-500 text-left'>Total No. of Records Delivered</h1>
            <h1 className='text-3xl font-bold text-gray-800 mt-3 text-left'><NumberAnimated n={sumColumn('recordD')} /></h1>
        </div>
        <div className='h-auto md:w-[32%] w-full bg-white bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 border-yellow-500 border-b-4 py-4 px-3 md:mt-0 mt-6 rounded-md'>
            <h1 className='text-lg text-gray-500 text-left'>Total No. of unacceptable emails</h1>
            <h1 className='text-3xl font-bold text-gray-800 mt-3 text-left'><NumberAnimated n={sumColumn('uEmail')} /></h1>
        </div>
        <div className='h-auto md:w-[32%] w-full bg-white bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 border-green-500 border-b-4 py-4 px-3 md:mt-0 mt-6 rounded-md'>
            <h1 className='text-lg text-gray-500 text-left'>Final No. of Records</h1>
            <h1 className='text-3xl font-bold text-gray-800 mt-3 text-left'><NumberAnimated n={sumColumn('fr')} /></h1>
        </div>
      </div>
      <div className="w-full h-auto flex justify-between items-center md:flex-row flex-col bg-white bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 p-4 mt-6 rounded-t-sm">
        <div className='md:w-[65%] w-full h-auto'>
        <form action="" className='w-full h-auto flex md:justify-between justify-center items-center flex-wrap'>
            <input className='py-2 px-4 rounded-sm' value={startDate} onChange={(e) => setStartDate(e.target.value)} type="date" name='do' id='do' />
            <input className='py-2 px-4  md:mt-0 mt-4 rounded-sm' value={endDate} onChange={(e) => setEndDate(e.target.value)} type="date" name='do' id='do' />
            <button onClick={filterData} className='py-2 px-4 md:mt-0 mt-4 bg-sky-600 hover:bg-sky-800 cursor-pointer text-white rounded-sm'>Filter</button>
            <button onClick={resetData} className='py-2 px-4 md:ml-0 ml-2 md:mt-0 mt-4 bg-red-600 hover:bg-red-800 cursor-pointer text-white rounded-sm'>Reset</button>
          </form>
        </div>
        <div className='md:w-[35%] w-full h-auto flex md:justify-end justify-center md:mt-0 mt-6'>
        {
            loggedInUsername === "admin" ?

             <Link to={"insert/bridged"}>
                <button className='py-2 px-4 bg-sky-600 hover:bg-sky-800 cursor-pointer text-white rounded-sm'><span className='font-bold'>&#x2b;</span> Add New Data</button>
              </Link>
              :
              ""
          }
        </div>
      </div>
      <div className="flex w-full h-auto flex-col overflow-x-auto bg-white bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70">
        <div className="w-full h-auto">
          <div className="inline-block min-w-full">
            <div className="overflow-x-auto">
              <table className="min-w-full text-start text-sm font-light text-surface  dark:text-white">
                <thead className="border-b border-neutral-200 bg-neutral-50 font-medium dark:border-white/10 dark:text-neutral-800">
                  <tr>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">#</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">File Name</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">Samples Provided</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">Project Type</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">Date Ordered</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">ETA</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">Billed Yet</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">Date Delivered</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">No. of Records Delivered</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">No. of unacceptable emails</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">Final No. of Records</th>
                    <th scope="col" className="whitespace-nowrap text-center px-6 py-4">Action</th>
                  </tr>
                </thead>
                <tbody>
                    {users.length > 0 ? (
                      users.map((userData, index) => (
                        <tr key={index} className="border-b border-neutral-200 dark:border-white/10">
  <td className="px-6 py-4 font-medium">{index+1}</td>
  <td className="whitespace-nowrap px-6 py-4">{userData.fileName}</td>
  <td className="whitespace-nowrap px-6 py-4">{userData.sample}</td>
  <td className="whitespace-nowrap px-6 py-4">{userData.ptype}</td>
  <td className="whitespace-nowrap px-6 py-4">{userData.do}</td>
  <td className="whitespace-nowrap px-6 py-4">{userData.eta}</td>
  <td className="whitespace-nowrap px-6 py-4">{userData.bill}</td>
  <td className="whitespace-nowrap px-6 py-4">{userData.dd}</td>
  <td className="whitespace-nowrap px-6 py-4">{userData.recordD}</td>
  <td className="whitespace-nowrap px-6 py-4">{userData.uEmail}</td>
  <td className="whitespace-nowrap px-6 py-4">{userData.fr}</td>
  <td className="whitespace-nowrap px-6 py-4">
    {isLoggedIn ? <Link to={`/update/bridged/${userData.ID}`}><FontAwesomeIcon className='text-green-600' icon={faEdit} /></Link> : ""}
    {loggedInUsername === "admin" ?
      <FontAwesomeIcon
        onClick={(e) => {
          e.preventDefault();
          console.log(`Clicked delete for user:`, userData); // Log entire userData
          deleteUser(userData.ID);
        }}
        className='text-red-600 ml-4'
        icon={faTrash}
      />
      :
      ""
    }
  </td>
</tr>

                      ))
                    ) : (
                      <tr>
                        <td colSpan='11'>No Data Found</td>
                      </tr>
                    )}
                  </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Bridged;
